/** T82 — Thương hiệu (logo + đầu/chân trang in + màu chủ đạo). Real /api/v1/clinic/branding. */
import { apiClient } from "./client";

export interface Branding {
  /** The tenant's clinic name — white-labels the app chrome (sidebar/topbar). */
  clinicName: string | null;
  headerText: string | null;
  footerText: string | null;
  primaryColor: string | null;
  /** Short-lived presigned GET URL for the logo, or null if unset. */
  logoUrl: string | null;
}

export interface BrandingUpdate {
  headerText?: string | null;
  footerText?: string | null;
  primaryColor?: string | null;
}

export const brandingApi = {
  get(): Promise<Branding> {
    return apiClient
      .get<Branding>("/v1/clinic/branding")
      .then((r) => r.data);
  },
  update(body: BrandingUpdate): Promise<Branding> {
    return apiClient
      .put<Branding>("/v1/clinic/branding", body)
      .then((r) => r.data);
  },
  uploadLogo(file: File): Promise<Branding> {
    const fd = new FormData();
    fd.append("file", file);
    return apiClient
      .post<Branding>("/v1/clinic/branding/logo", fd)
      .then((r) => r.data);
  },
};

export const brandingQueryKeys = {
  all: () => ["clinic-branding"] as const,
};
